import { CSSProperties, ReactNode, Ref, createElement } from 'react';
import { cn } from 'shared/utils/cn';

export type EyebrowElement = 'span' | 'p' | 'div' | 'label';

export interface EyebrowProps {
  as?: EyebrowElement;
  htmlFor?: string;
  className?: string;
  style?: CSSProperties;
  innerRef?: Ref<HTMLElement>;
  children: ReactNode;
}

export const Eyebrow = ({
  as = 'span',
  htmlFor,
  className,
  style,
  innerRef,
  children,
}: EyebrowProps) => {
  return createElement(
    as,
    {
      style,
      ref: innerRef,
      htmlFor: as === 'label' ? htmlFor : undefined,
      className: cn(
        'font-sans text-xs uppercase tracking-widest text-tertiary font-bold',
        className,
      ),
    },
    children,
  );
};
